import type { OnboardingAnswerRequest } from '../types/onboarding';
import { api, type ApiResponse } from '../utils';

const getOnboardingQuestion = async (): Promise<ApiResponse> => {
  try {
    const response = await api.get('/onboarding/question');
    return response.data;
  } catch (error: any) {
    return {
      code: error?.code || 500,
      message: error?.message || 'Failed to get onboarding question',
      result: null,
    };
  }
};

const getOnboardingAnswers = async (): Promise<ApiResponse> => {
  try {
    const response = await api.get('/onboarding/answers');
    return response.data;
  } catch (error: any) {
    return {
      code: error?.code || 500,
      message: error?.message || 'Failed to get onboarding answers',
      result: null,
    };
  }
};

const getOnboardingProgress = async (): Promise<ApiResponse> => {
  try {
    const response = await api.get('/onboarding/progress');
    return response.data;
  } catch (error: any) {
    return {
      code: error?.code || 500,
      message: error?.message || 'Failed to get onboarding progress',
      result: null,
    };
  }
};

const submitOnboardingAnswer = async (
  data: OnboardingAnswerRequest
): Promise<ApiResponse> => {
  try {
    const response = await api.post('/onboarding/submit-question', data);
    return response.data;
  } catch (error: any) {
    return {
      code: error?.code || 500,
      message: error?.message || 'Failed to submit onboarding answer',
      result: null,
    };
  }
};

const updateOnboardingAnswer = async (
  data: OnboardingAnswerRequest
): Promise<ApiResponse> => {
  try {
    const response = await api.post('/onboarding/update-question', data);
    return response.data;
  } catch (error: any) {
    return {
      code: error?.code || 500,
      message: error?.message || 'Failed to update onboarding answer',
      result: null,
    };
  }
};

const uploadResume = async (file: File): Promise<ApiResponse> => {
  const formData = new FormData();
  formData.append('file', file);

  try {
    const response = await api.post('/onboarding/upload-resume', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error: any) {
    return {
      code: error?.code || 500,
      message: error?.message || 'Failed to upload resume',
      result: null,
    };
  }
};

export {
  getOnboardingQuestion,
  getOnboardingAnswers,
  getOnboardingProgress,
  submitOnboardingAnswer,
  updateOnboardingAnswer,
  uploadResume,
};
